<template>
  <div id="institute-home">
    <div class="top">
      <div class="top-left">
        <!-- 标签栏 -->
        <div class="nav">
          <div class="menus">
            <div
              class="menu"
              v-for="(item, index) in nav_list"
              :key="index"
              @click="handleSelect(item.title, index)"
            >
              <span :class="activeIndex == index ? 'active' : ''">{{
                item.title
              }}</span>
              <div
                class="line"
                :style="{ background: activeIndex == index ? '#1E74FF' : '' }"
              ></div>
            </div>
          </div>
          <div class="nav-right">
            <div class="nav-search">
              <input
                type="text"
                @input="searchTitle"
                v-model="search_words"
                placeholder="大家都在搜：留学申请"
              />
              <img
                @click.stop="jumpItem"
                class="pointer"
                src="@/assets/img/pygh_index/search.png"
              />
            </div>

            <div class="plus visible-xs" @click.stop="jumpItem">
              <img src="@/assets/img/pygh_index/jia.png" alt="" />
            </div>
          </div>
        </div>

        <!-- 轮播图 -->
        <div class="carousel">
          <!-- 骨架屏 -->
          <el-skeleton
            style="width: 100%; height: 4.98rem; background-color: #ffffff;"
            class=""
            v-if="carousel_list.length === 0"
            :animated="true"
          >
            <template slot="template">
              <el-skeleton-item
                variant="image"
                style="width: 100%; height: 3.52rem;"
              />
              <div style="padding: 0.2rem 0.3rem 0.24rem; textAlign: left;">
                <el-skeleton-item variant="p" style="width: 50%" />
              </div>

              <div
                style="display: flex; align-items: center; justify-items: space-between;padding: 0 0.3rem 0.22rem;"
              >
                <el-skeleton-item
                  variant="circle"
                  class="hidden-xs"
                  style="margin-right: 16px;"
                />
                <div style="flex: 1; textAlign: left;;">
                  <el-skeleton-item variant="text" style="width: 30%;" />
                  <el-skeleton-item variant="text" style="width: 100%;" />
                </div>
              </div>
            </template>
          </el-skeleton>

          <!-- 背景模糊 -->
          <div
            class="carousel-container"
            v-if="carousel_list.length > 0"
            :style="{ backgroundImage: 'url(' + bgc_img + ')' }"
          >
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  v-for="(item, index) in carousel_list"
                  class="swiper-slide pointer"
                  @click.stop="toQaDetail(item)"
                  :key="index"
                >
                  <!-- <div class="bgc "
                 :style="{'backgroundImage': 'url(' + item.cover +')'}">
            </div> -->
                  <div class="item-top" v-if="item.cover">
                    <img :src="item.cover" alt="" />
                  </div>
                  <div class="item-title title-bold" v-if="item">
                    {{ item.title }}
                    <div
                      class="tag visible-xs"
                      v-if="item.tag_list_text.length > 0"
                      :style="{
                        color: item.tag_list_text[0].color,
                        backgroundColor: item.tag_list_text[0].bg_color
                      }"
                    >
                      {{ item.tag_list_text[0].name }}
                    </div>
                  </div>
                  <div class="item-bottom">
                    <div class="info" v-if="item.oauth_user">
                      <div class="header hidden-xs">
                        <img :src="item.oauth_user.avatar" />
                      </div>
                      <div class="name-birthday">
                        <div class="name hidden-xs">
                          {{ item.oauth_user.nickname }}
                          <div class="name-label" v-if="item.user_tag_name">
                            {{ item.user_tag_name }}
                          </div>
                        </div>
                        <div class="birth">{{ item.create_time }}</div>
                      </div>
                    </div>
                    <div class="item-bottom-right">
                      <div class="see">
                        <img
                          class="visible-xs"
                          src="../../assets/img/pygh_index/see.png"
                        />
                        <span>浏览&nbsp;{{ item.watch }}</span>
                      </div>
                      <div class="circle hidden-xs"></div>
                      <div class="common">
                        <img
                          class="visible-xs"
                          src="../../assets/img/pygh_qa/pinlun.png"
                        />
                        <span>评论&nbsp;{{ item.comment_num }}</span>
                      </div>
                      <div class="circle hidden-xs"></div>
                      <div class="like">
                        <img
                          class="visible-xs"
                          src="../../assets/img/pygh_qa/dianzan.png"
                        />
                        <span>点赞&nbsp;{{ item.like }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>

      <!-- 发布文章部分 -->
      <div class="top-right hidden-xs">
        <div class="release-article" @click.stop="showToast">
          <div class="img">
            <img src="@/assets/img/pygh_index/fabuwenzhang.png" />
          </div>
          <div class="word">
            <div class="title">发布文章</div>
            <div class="desc">在线编辑你的文章</div>
          </div>
        </div>

        <div class="card1" v-if="carousel_list.length === 0">
          <el-skeleton style="width: 100%" :animated="true">
            <template slot="template">
              <el-skeleton-item
                variant="image"
                style="width: 100%; height: 1.66rem;"
              />
              <el-skeleton-item
                variant="p"
                style="width: 50%; margin: 0.12rem 0.16rem 0.08rem;"
              />
              <div class="card1-content">
                <div class="card1-content-left card1-content-left-skeleton">
                  <el-skeleton-item variant="circle" class="header" />
                  <el-skeleton-item variant="text" style="width: 30%;" />
                </div>
                <el-skeleton-item variant="text" style="width: 20%;" />
              </div>
            </template>
          </el-skeleton>
        </div>

        <div
          class="card1"
          v-if="carousel_list[0]"
          @click.stop="toQaDetail(carousel_list[0])"
        >
          <div class="card1-img" v-if="carousel_list[0].cover">
            <img :src="carousel_list[0].cover" />
          </div>
          <div class="card1-title title-bold">
            {{ carousel_list[0].title }}
          </div>
          <div class="card1-content">
            <div class="card1-content-left">
              <div class="header">
                <img :src="carousel_list[0].oauth_user.avatar" />
              </div>
              <div class="name">{{ carousel_list[0].oauth_user.nickname }}</div>
            </div>
            <span class="card1-content-right"
              >浏览&nbsp;{{ carousel_list[0].watch }}</span
            >
          </div>
        </div>

        <div class="card2" v-if="carousel_list.length === 0">
          <el-skeleton style="width: 100%" :animated="true">
            <template slot="template">
              <el-skeleton-item
                variant="image"
                style="width: 100%; height: 1.66rem;"
              />
              <el-skeleton-item
                variant="p"
                style="width: 50%; margin: 0.12rem 0.16rem 0.08rem;"
              />
              <div class="card1-content">
                <div class="card1-content-left card1-content-left-skeleton">
                  <el-skeleton-item variant="circle" class="header" />
                  <el-skeleton-item variant="text" style="width: 30%;" />
                </div>
                <el-skeleton-item variant="text" style="width: 20%;" />
              </div>
            </template>
          </el-skeleton>
        </div>

        <div
          class="card2"
          v-if="carousel_list.length > 1"
          @click.stop="toQaDetail(carousel_list[1])"
        >
          <div class="card2-img" v-if="carousel_list[1].cover">
            <img :src="carousel_list[1].cover" />
          </div>
          <div class="card2-title title-bold">
            {{ carousel_list[1].title }}
          </div>
          <div class="card2-content">
            <div class="card2-content-left">
              <div class="header">
                <img :src="carousel_list[1].oauth_user.avatar" />
              </div>
              <div class="name">{{ carousel_list[1].oauth_user.nickname }}</div>
            </div>
            <span class="card1-content-right"
              >浏览&nbsp;{{ carousel_list[1].watch }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 广告 -->
    <div class="adv-banner hidden-xs pointer" v-if="adData.length > 0">
      <img :src="adData[0].img_path" @click.stop="ckAd" />
    </div>

    <!-- 文章推荐 -->
    <div
      class="recod-article"
      :class="adData.length > 0 ? '' : 'recod-article-top'"
    >
      <div class="recod-article-title title-bold">为你推荐</div>
      <div class="recod-article-desc">更多研究，更多启发</div>
      <!-- pc -->
      <ul class="hidden-xs">
        <li
          v-for="(item, index) in list"
          :key="index"
          class="li pointer"
          @click.stop="toQaDetail(item)"
        >
          <div class="li-left" v-if="item.cover">
            <el-image :src="item.cover" lazy></el-image>
          </div>
          <div class="li-right">
            <div class="li-right-top">
              <div class="li-right-top-title">
                <span class="title-bold">{{ item.title }}</span>
                <div
                  class="tag"
                  v-if="item.tag_list_text.length > 0"
                  :style="{
                    color: item.tag_list_text[0].color,
                    backgroundColor: item.tag_list_text[0].bg_color
                  }"
                >
                  {{ item.tag_list_text[0].name }}
                </div>
              </div>
              <div class="li-right-desc">{{ item.article_guide }}</div>
            </div>
            <div class="li-right-bottom">
              <div class="info">
                <div class="header">
                  <el-image :src="item.oauth_user.avatar" lazy></el-image>
                </div>
                <div class="name-birthday">
                  <div class="name">{{ item.oauth_user.nickname }}</div>
                  <!-- <div class="birth">{{item.create_time}}</div> -->
                </div>
              </div>
              <div class="li-right-bottom-right">
                <span>浏览&nbsp;{{ item.watch }}</span>
                <div class="circle"></div>
                <span>评论&nbsp;{{ item.comment_num }}</span>
                <div class="circle"></div>
                <span>点赞&nbsp;{{ item.like }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>

      <!-- phone -->
      <ul class="visible-xs">
        <li
          v-for="(item, index) in list"
          :key="index"
          class="li pointer"
          @click.stop="toQaDetail(item)"
        >
          <div class="li-left">
            <el-image :src="item.cover" lazy></el-image>
          </div>
          <div class="li-right">
            <div class="li-right-top">
              <div class="title title-bold">{{ item.title }}</div>
              <div class="desc">{{ item.article_guide }}</div>
            </div>
            <div class="info">
              <div class="header">
                <el-image :src="item.oauth_user.avatar" lazy></el-image>
              </div>
              <div class="name">{{ item.oauth_user.nickname }}</div>
            </div>
          </div>
        </li>
      </ul>

      <!-- pc -->
      <div class="more-article pointer hidden-xs" @click="changebatch">
        <i class="el-icon-refresh-right"></i><span>换一批</span>
      </div>

      <!-- phone -->
      <div class="change pointer visible-xs" @click.stop="changebatch">
        <i class="el-icon-refresh-right"></i>换一批
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import cookie from "@/utils/cookie";
import { home, changebatch, articlelist, adList } from "@/api/home";

export default {
  name: "HomePage",
  data() {
    return {
      page: 1,

      // 背景模糊图片
      bgc_img: "",

      search_words: "",
      search_list: [],

      list: [],

      activeIndex: 0,

      show_detail: false,

      // 标签栏
      nav_list: [
        {
          title: "留学研究所",
          children: []
        }
      ],

      // 首页数据
      homeData: [],
      adData: {},

      // 轮播图列表
      carousel_list: [],

      // 推荐列表
      recod_list: [],
      is_more: true
    };
  },
  created() {
    this.adList();
    this.articlelist();
    if (document.documentElement.clientWidth <= 768) {
    }
  },
  mounted() {
    this.home();
  },
  watch: {
    $route(to) {
      if (to.name === "institute_detail") this.show_detail = true;
      else this.show_detail = false;
    }
  },
  computed: {},
  methods: {
    // 初始化swiper
    swiper() {
      let _this = this;

      let data = {
        loop: true, // 循环模式选项
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        observeSlideChildren: true,
        on: {
          slideChange: function() {
            if (this.activeIndex > _this.carousel_list.length) {
              _this.bgc_img = _this.carousel_list[0].cover;
            } else {
              _this.bgc_img = _this.carousel_list[this.activeIndex - 1].cover;
            }
          }
        }
      };

      new Swiper(".swiper-container", data);
    },

    // 广告列表
    async adList() {
      let data = {
        ad_type: "institute_center_ad"
      };

      const { data: res } = await adList(data);
      console.log("广告", res.data);
      this.adData = res.data;
    },

    // 点击广告
    ckAd() {
      window.open(this.adData[0].url);
    },

    // 跳转至目标
    jumpItem() {
      // if (this.search_list.length === 0) {
      //   this.$message.error('暂无内容')
      //   return
      // }
      this.$router.push({
        name: "institute_search"
      });

      document.querySelector(".recod-article-desc").scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    },

    // 标签栏
    handleSelect(title, key) {
      this.activeIndex = key;
      let el = document.querySelector(".menus");
      let menu = document.querySelector(".menu");
      if (key >= 3) el.scrollBy(menu.clientWidth, 0);
      else el.scrollBy(-menu.clientWidth, 0);
    },

    showToast() {
      return this.$message.success("敬请期待！");

      if (
        !cookie.getCookie("token") ||
        !window.sessionStorage.getItem("token")
      ) {
        this.$store.commit("ckloginDialog", true);
        return;
      }

      const { href } = this.$router.resolve({
        name: "edit_article"
      });

      window.open(href, "_blank");
    },

    // 更多文章
    moreArticle() {
      if (this.is_more) {
        this.page++;
        this.articlelist();
      }
    },

    // 为你推荐列表
    async articlelist() {
      let data = {
        page: this.page,
        limit: "5"
      };
      const { data: res } = await articlelist(data);
      if (res.data.data.length === 0) {
        this.is_more = false;
        return;
      }
      this.list = this.recod_list = [...this.recod_list, ...res.data.data];
      console.log("文章列表", this.list);
    },

    // 首页初始化数据
    async home() {
      const { data: res } = await home();
      console.log("首页", res.data);
      this.homeData = res.data;
      res.data.forEach(item => {
        if (item.show_type === "big_img")
          this.carousel_list = item.article_list;
      });
      this.$nextTick(() => {
        this.swiper();
      });
      console.log("轮播图", this.carousel_list);
      this.bgc_img = this.carousel_list[0].cover;
    },

    // 搜索标题
    searchTitle() {
      if (!this.search_words) {
        this.search_list = [];
        this.list = this.recod_list;
        return;
      }

      this.search_list = [];
      this.recod_list.forEach((item, index) => {
        if (item.title.indexOf(this.search_words) !== -1)
          this.search_list.push(item);
      });
      if (this.search_list.length !== 0) this.list = this.search_list;
      else this.list = this.recod_list;

      console.log(this.search_list);
    },

    // 进入研究所详情
    toQaDetail(item) {
      this.$store.commit("changeInstituteTitle", item.title);
      console.log(this.$store.state.institute_title);

      const { href } = this.$router.resolve({
        name: "institute_detail",
        query: {
          id: item.id
        }
      });
      window.open(href, "_blank");
    },

    // 换一批
    async changebatch() {
      let id;
      this.homeData.forEach(item => {
        if (item.show_type === "list") id = item.id;
      });
      let data = {
        module_id: id
      };
      const { data: res } = await changebatch(data);
      console.log(res.data);
      this.list = this.recod_list = res.data.slice(0, 5);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/common.scss";

/* 整体盒子 */
#institute-home {
  width: 100%;
  padding: 0 0 0.7rem;
  background: #f5f6fa;

  .top {
    width: 100%;
    @include flex-line-between;
    align-items: flex-start;

    &-left {
      width: 8.86rem;
    }

    &-right {
      width: 3.16rem;

      .release-article {
        cursor: pointer;
        width: 100%;
        height: 0.96rem;
        padding-left: 0.3rem;
        @include flex-line-center;
        justify-content: flex-start;
        background: linear-gradient(90deg, #f9c258 0%, #ea7a27 100%);
        box-shadow: 0px 8px 16px 0px rgba(225, 206, 179, 0.5);
        border-radius: 0.05rem;

        .img {
          width: 0.8rem;
          height: 0.88rem;
          margin-right: 0.2rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .word {
          color: #fff;
          font-size: 0.24rem;

          .desc {
            text-align: center;
            color: #f6f2ef;
            font-size: 0.14rem;
            margin-top: 0.08rem;
          }
        }
      }

      .card1,
      .card2 {
        cursor: pointer;
        font-size: 0.14rem;
        background: #fff;
        border-radius: 0.05rem;
        margin-top: 0.3rem;

        &-img {
          width: 100%;
          height: 1.66rem;
          overflow: hidden;

          img {
            transition: all ease 0.6s;
            border-radius: 0.05rem 0.05rem 0 0;
          }
        }

        &-img:hover {
          img {
            transition: all ease 0.6s;
            transform: scale(1.05);
          }
        }

        &-title {
          width: 100%;
          @include text-ellipse;
          padding: 0.12rem 0.16rem 0.08rem;
        }

        &-content {
          width: 100%;
          font-size: 0.12rem;
          padding: 0 0.16rem 0.12rem;
          @include flex-line-between;

          &-left {
            @include flex-line-start;

            .header {
              width: 0.22rem;
              height: 0.22rem;
              margin-right: 0.08rem;

              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }

            &-skeleton {
              flex: 1;
            }
          }

          &-right {
            color: $tips-color;
          }
        }
      }

      .card2 {
        margin-top: 0.2rem;
      }
    }
  }
}

// 轮播图
.carousel {
  width: 100%;

  &-container {
    width: 100%;
    height: 4.98rem;
    position: relative;
    border-radius: 0.05rem;
    background-size: 100% 100%;
    background-repeat: no-repeat center center;

    &::after {
      content: "";
      position: absolute;
      top: 3%;
      left: 50%;
      transform: translateX(-50%);
      width: 98%;
      height: 97%;
      background: inherit;
      background-size: 100% 100%;
      filter: blur(12px) brightness(60%) opacity(0.6);
    }
  }

  .swiper-container {
    width: 100%;
    height: 100%;
    border-radius: 0.05rem;

    .swiper-slide {
      width: 100%;
      height: 100%;
      z-index: 6;
      position: relative;
      background-color: #ffffff;

      .item-top {
        width: 100%;
        height: 3.52rem;

        img {
          width: 100%;
          height: 100%;
          transition: all ease 0.6s;
          border-radius: 0.05rem 0.05rem 0 0;
        }
      }

      .item-top:hover {
        img {
          transition: all ease 0.6s;
          transform: scale(1.05);
        }
      }

      .item-title {
        width: 100%;
        @include flex-line-start;
        font-size: 0.24rem;
        padding: 0.2rem 0.3rem 0.24rem;
        position: relative;
        background-color: #fff;
      }

      .item-bottom {
        width: 100%;
        z-index: 6;
        background-color: #fff;
        border-radius: 0 0 0.05rem 0.05rem;
        @include flex-line-between;
        align-items: flex-end;
        padding: 0 0.3rem 0.22rem;

        .info {
          @include flex-line-start;

          .header {
            width: 0.48rem;
            height: 0.48rem;
            margin-right: 0.12rem;

            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }

          .name-birthday {
            font-size: 0.16rem;

            .name {
              @include flex-line-start;
              margin-bottom: 0.06rem;

              &-label {
                color: $orange-color;
                @include flex-line-center;
                font-size: 0.12rem;
                min-width: 0.76rem;
                height: 0.25rem;
                margin-left: 0.12rem;
                background: #ffffff;
                border-radius: 0.12rem;
                border: 1px solid $orange-color;
              }
            }

            .birth {
              color: $tips-color;
              font-size: 0.14rem;
            }
          }
        }

        &-right {
          color: $tips-color;
          font-size: 0.14rem;
          @include flex-line-end;

          .circle {
            width: 0.02rem;
            height: 0.02rem;
            border-radius: 50%;
            margin: 0 0.05rem;
            background-color: $tips-color;
            position: relative;
          }
        }
      }
    }
  }

  .swiper-pagination {
    width: 100%;
    height: 1rem;
    text-align: center;
    margin-top: 0.2rem;

    /deep/ .swiper-pagination-bullet {
      width: 0.24rem;
      height: 0.05rem;
      background: #1e74ff;
      border-radius: 0.03rem;
      opacity: 0.1;
      margin-right: 0.08rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      width: 0.48rem;
      opacity: 1;
      border-radius: 0.05rem;
      transition: all ease 0.3s;
    }

    /deep/ .swiper-pagination-bullet:last-of-type {
      margin-right: 0;
    }
  }
}

// S-首页左边

.nav {
  width: 100%;
  height: 0.96rem;
  background: #ffffff;
  box-shadow: 0px 0.02rem 0.04rem 0px rgba(231, 231, 231, 0.5);
  border-radius: 0.05rem;
  @include flex-line-between;
  padding-left: 0.24rem;
  padding-right: 0.2rem;
  margin-bottom: 0.3rem;

  .menus {
    width: calc(100% - 3.7rem);
    height: 100%;
    white-space: nowrap;
    overflow-x: scroll;
    display: flex;
    margin-right: 0.2rem;

    .menu {
      // min-width: 0.9rem;
      color: #70798c;
      cursor: pointer;
      margin-right: 0.48rem;
      font-size: 0.16rem;
      position: relative;
      @include flex-line-center;

      .line {
        width: 0.48rem;
        height: 0.05rem;
        bottom: 0;
        border-radius: 0.03rem;
        position: absolute;
      }
    }

    .menu:last-of-type {
      margin-right: 0;
    }

    .active {
      font-size: 0.18rem;
      font-weight: bold;
      color: $word-color;
    }
  }

  .menus::-webkit-scrollbar {
    display: none;
  }

  &-search {
    width: 3.26rem;
    height: 0.48rem;
    padding: 0 0.2rem;
    @include flex-line-between;
    background: #f7f7f7;
    border-radius: 0.05rem;
    z-index: 6;
    border: 1px solid $line-color;

    input {
      flex: 1;
      font-size: 0.16rem;
      background: none;
    }

    input::placeholder {
      color: #c0c3cd;
    }

    img {
      width: 0.22rem;
      height: 0.22rem;
    }
  }
}

// 广告页
.adv-banner {
  width: 100%;
  height: 1.48rem;
  margin-top: 0.75rem;

  img {
    border-radius: 0.05rem;
  }
}

// 文章推荐
.recod-article {
  margin-top: 0.4rem;
  background: #fff;
  padding: 0.3rem 0.3rem 0.24rem;
  border-radius: 0.05rem;

  &-title {
    font-size: 0.24rem;
  }

  &-desc {
    color: $tips-color;
    font-size: 0.14rem;
    margin: 0.08rem 0 0.24rem;
  }

  ul {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: -0.05rem;
      width: 1.02rem;
      height: 0.05rem;
      background: $main-color;
      border-radius: 0.03rem;
    }

    .li {
      width: 100%;
      padding: 0.3rem 0 0;
      background: #ffffff;
      margin-bottom: 0.3rem;
      position: relative;
      @include flex-line-between;

      &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        top: 0;
        background: #e4e7ed;
      }

      &-left {
        width: 3rem;
        height: 1.68rem;
        margin-right: 0.2rem;
        overflow: hidden;

        /deep/ .el-image,
        img {
          width: 100%;
          height: 100%;
          transition: all ease 0.6s;
          border-radius: 0.05rem;
        }
      }

      &-left:hover {
        /deep/ .el-image,
        img {
          transition: all ease 0.6s;
          transform: scale(1.05);
        }
      }

      &-right {
        flex: 1;
        height: 1.68rem;
        @include flex-colume-between;

        &-top {
          font-size: 0.2rem;

          &-title {
            font-size: 0.18rem;
            @include flex-line-start;

            .tag {
              min-width: 0.82rem;
              min-height: 0.32rem;
              font-size: 0.14rem;
              color: $orange-color;
              @include flex-line-center;
              border-radius: 0.01rem 0.15rem 0.01rem 0.15rem;
              background: rgba(234, 122, 39, 0.09);
              margin-left: 0.08rem;
            }
          }
        }

        &-desc {
          width: 100%;
          color: #666666;
          font-size: 0.14rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
          margin-top: 0.12rem;
          line-height: 0.24rem;
        }

        &-bottom {
          width: 100%;
          border-radius: 0 0 0.05rem 0.05rem;
          @include flex-line-between;
          padding: 0.15rem 0 0;

          .info {
            @include flex-line-start;

            .header {
              width: 0.22rem;
              height: 0.22rem;
              margin-right: 0.12rem;

              /deep/ .el-image,
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }

            .name-birthday {
              font-size: 0.12rem;

              .birth {
                color: $tips-color;
                font-size: 0.12rem;
              }
            }
          }

          &-right {
            color: $tips-color;
            font-size: 0.12rem;
            @include flex-line-end;

            .circle {
              width: 0.02rem;
              height: 0.02rem;
              border-radius: 50%;
              margin: 0 0.05rem;
              background-color: $tips-color;
              position: relative;
            }
          }
        }
      }
    }
  }

  .more-article {
    color: $main-color;
    width: 100%;
    font-size: 0.16rem;
    padding-top: 0.24rem;
    @include flex-line-center;
    background: #ffffff;
    position: relative;

    span {
      margin-left: 0.05rem;
    }

    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 1px;
      top: 0;
      background: #e4e7ed;
    }
  }
}

.recod-article-top {
  margin-top: 0.7rem;
}

// E-首页左边

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #institute-home {
    background: #fff;
    padding-bottom: 0.4rem;

    .top {
      width: 100%;

      &-left {
        width: 100%;
      }
    }

    .nav {
      box-shadow: none;
      height: 100%;
      padding: 0;
      margin-bottom: 0.3rem;
      flex-direction: column-reverse;
      align-items: flex-start;

      .menus {
        width: 100%;
        margin-top: 0.28rem;
        margin-right: 0;

        .menu {
          padding-bottom: 0.16rem;
          font-size: 0.28rem;
          margin-right: 0.32rem;

          .line {
            width: 0.48rem;
            height: 0.05rem;
            bottom: 0;
            z-index: 6;
          }
        }

        .active {
          font-size: 0.32rem;
        }
      }

      &-right {
        width: 100%;
        @include flex-line-between;

        .plus {
          width: 0.38rem;
          height: 0.38rem;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      &-search {
        width: 6.22rem;
        height: 0.68rem;
        background: #f5f6fa;
        border: none;
        border-radius: 0.1rem;
        flex-direction: row-reverse;

        input {
          font-size: 0.24rem;
        }

        img {
          width: 0.28rem;
          height: 0.28rem;
          margin-right: 0.16rem;
        }
      }
    }

    // 轮播图
    .carousel {
      width: 100%;
      font-size: 0.28rem;
      margin: 0;
      text-align: center;

      &-container {
        height: 6.36rem;
        border-radius: 0.1rem;
      }

      .swiper-container {
        height: 100%;
        border-radius: 0.1rem;

        .swiper-slide {
          height: 100%;
          @include flex-colume-between;

          .bgc {
            width: 100%;
            height: 100%;
            filter: blur(20px) brightness(80%) opacity(0.8);
          }

          .item-top {
            height: 3.88rem;
          }

          .item-title {
            font-size: 0.32rem;
            min-height: 1.54rem;
            text-align: left;
            flex-direction: column;
            align-items: flex-start;
            padding-bottom: 0.24rem;

            .tag {
              width: 0.96rem;
              height: 0.36rem;
              font-size: 0.2rem;
              margin-top: 0.08rem;
              text-align: center;
              line-height: 0.36rem;
              border-radius: 0.01rem 0.15rem 0.01rem 0.15rem;
            }
          }

          .item-bottom {
            padding-top: 0.2rem;
            position: relative;
            border-radius: 0 0 0.1rem 0.1rem;

            &::before {
              content: "";
              position: absolute;
              width: calc(100% - 0.6rem);
              height: 1px;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
              background: #e4e7ed;
            }

            .info {
              .name-birthday {
                .birth {
                  font-size: 0.2rem;
                }
              }
            }

            &-right {
              font-size: 0.2rem;

              .see {
                margin-right: 0.32rem;
                @include flex-line-start;

                img {
                  width: 0.28rem;
                  height: 0.2rem;
                }
              }

              .common {
                margin-right: 0.38rem;
                @include flex-line-start;

                img {
                  width: 0.24rem;
                  height: 0.24rem;
                  margin-bottom: 0.04rem;
                }
              }

              .like {
                @include flex-line-start;

                img {
                  width: 0.21rem;
                  height: 0.22rem;
                  margin-bottom: 0.04rem;
                }
              }

              span {
                margin-left: 0.12rem;
              }
            }
          }
        }
      }
    }

    // 文章推荐
    .recod-article {
      padding: 0;
      margin-top: 0.92rem;

      &-title {
        font-size: 0.32rem;
      }

      &-desc {
        font-size: 0.24rem;
        margin: 0.08rem 0 0.3rem;
      }

      ul {
        &::after {
          display: none;
        }

        .li {
          width: 100%;
          height: 1.64rem;
          padding: 0;
          margin-bottom: 0.32rem;
          padding: 0;
          box-shadow: none;
          @include flex-line-between;

          &::before {
            display: none;
          }

          &-left {
            width: 1.64rem;
            height: 1.64rem;
            margin-right: 0.24rem;

            /deep/ .el-image,
            img {
              width: 100%;
              height: 100%;
              border-radius: 0.1rem;
            }
          }

          &-right {
            flex: 1;
            height: 100%;
            @include flex-colume-between;
            align-items: flex-start;
            color: $tips-color;
            font-size: 0.24rem;

            .title {
              color: #333;
              font-size: 0.28rem;
              margin-bottom: 0.12rem;
            }

            .desc {
              width: 5rem;
              @include text-ellipse;
            }

            .info {
              @include flex-line-start;

              .header {
                width: 0.34rem;
                height: 0.34rem;
                margin-right: 0.12rem;

                /deep/ .el-image,
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                }
              }
            }
          }
        }
      }
    }

    .change {
      color: #9ea5b8;
      font-size: 0.24rem;
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      @include flex-line-center;
      background: #ffffff;
      margin-bottom: 0.54rem;
      border-radius: 0.1rem;
      border: 0.02rem solid #e4e7ed;

      i {
        font-size: 0.28rem;
        margin-right: 0.08rem;
      }
    }
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #institute-home {
    .top {
      &-left {
        width: 7.5rem;
      }

      &-right {
        width: 3.16rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/institute/institute_home.vue